export type FaqItemData = {
  question: string;
  answer: string;
  linkText?: string;
  linkHref?: string;
};

export const pricingFaqData = [
  {
    question: "Can I cancel my plan at any time?",
    answer:
      "Yes! You can cancel your plan at any time and you keep your benefits till the end of the period!",
  },
  {
    question: "Can I upgrade or downgrade my plan?",
    answer: "Yes, your plan can be updated at any point!",
  },
  // {
  //   question: "What if I want to train my voice again?",
  //   answer:
  //     "If for whatever reason you are not satisfied with your voice, you can delete and train the voice again as many times as you like. The maximum number of voices you can have at once is determined by your plan.",
  // },
  {
    question: "What happens if I cancel my subscription?",
    answer: `After canceling your subscription, you’ll retain access to your extra features until your billing period ends.`,
  },
  // {
  //   question: "Are my generations available for commercial use?",
  //   answer:
  //     "If your plan includes a commercial license you are free to use your generations for commercial use. You fully own the rights to your generations, as long as the voice you used was trained on copyright free data. All AudioModify models are trained on copyright free data.",
  // },
  // {
  //   question: "Which plans allow me to create custom voices?",
  //   answer: "Custom voices are available in any paid pricing plan!",
  // },
  // {
  //   question: "Can I download the converted files for free?",
  //   answer:
  //     "Yes, you can dowload the full cover song for free. If you are a AudioModify subscriber, you can also download the vocal version, and instrumental version of the song.",
  // },
  // {
  //   question: "Does this work in every language?",
  //   answer:
  //     "Yes this works in every language. We do not convert your words, rather we convert the notes and pitch of the voice.",
  // },
  // {
  //   question: "What does custom model mean?",
  //   answer:
  //     "Custom voice model means that we utilize your uploaded personal voice data and employ AI machine training to create a personalized model exclusively for your private use.",
  // },
  {
    question:
      "How to separate vocals, melodies, bass and drums from audio file?",
    answer: `You can do it using our`,
    linkText: "Stem Splitter",
    linkHref: "/stem-splitter",
  },
  {
    question: "How to remove vocals?",
    answer: `You can do it using our`,
    linkText: "Vocal Remover",
    linkHref: "/vocal-remover",
  },
  {
    question: "How to remove instrumental?",
    answer: `You can do it using our`,
    linkText: "Instrumental Remover",
    linkHref: "/stem-splitter",
  },
] as FaqItemData[];

export const mainFaqData = [...pricingFaqData];
